import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    Divider,
    List,
    ListItem,
    ListItemText
} from '@mui/material';
//import HeaderBar from '../components/ui/HeaderBar';
import nwLogo from '../assets/images/Infinium.png';
import splashImage from '../assets/images/infiniumsplash.png';

const assessmentInfo = {
    'resource-capability': {
        title: 'Individual Capability Assessment',
        duration: '25 - 45 minutes',
        //description: 'ADD DESCRIPTION HERE',
        instructions: [
            'This section assesses your individual skills, knowledge, and areas of expertise relevant to your role. The focus is on understanding your current capabilities, how you approach your work, and where opportunities for growth and development may exist.',
            'Please respond openly and thoughtfully. The collected answers are intended to support a constructive conversation about professional development of the teams and are not used to evaluate or judge your performance. Responses will not be held against you.'
        ]
    },
    'project-delivery': {
        title: 'Project Delivery Assessment',
        duration: '25 - 45 minutes',
        //description: 'ADD DESCRIPTION HERE',
        instructions: [
            'This section assesses the project deliveries to date. The focus is on what has been delivered, the working practices in place, and potential opportunities and recommendations for improvement.',
            'Please respond openly and thoughtfully. Your answers are intended to support a constructive conversation and are not used to evaluate or judge your performance. Responses will not be held against you.'
        ]
    },
    'platform-solution': {
        title: 'Platform Solution Assessment',
        duration: '25 - 45 minutes',
        //description: 'ADD DESCRIPTION HERE',
        instructions: [
            'This section assesses understanding and application of the platform solution in the context of the current engagement. The focus is on how the platform is being utilised, the extent to which it aligns with business objectives, and any opportunities for improvement or optimisation.',
            'Please respond openly and thoughtfully. Your answers are intended to support a constructive conversation and are not used to evaluate or judge your performance. Responses will not be held against you.'
        ]
    },
    'testing': {
        title: 'Platform Solution Assessment',
        duration: '25 - 45 minutes',
        //description: 'ADD DESCRIPTION HERE',
        instructions: [
            'This section assesses the testing practices and processes in place within the engagement. The focus is on the approaches being used, the quality and coverage of testing activity, and opportunities to strengthen delivery confidence.',
            'Please respond openly and thoughtfully. Your answers are intended to support a constructive conversation and are not used to evaluate or judge your performance. Responses will not be held against you.'
        ]
    }
};

const AssessmentInfoPage = () => {
    const { userId, application } = useParams();
    const navigate = useNavigate();

    const info = assessmentInfo[application] || {
        title: 'Assessment',
        duration: '',
        description: '',
        instructions: [],
        note: ''
    };

    return (
        <Box position="relative" minHeight="100vh" overflow="hidden">
            {/* Logo */}
            <Box sx={{ position: 'absolute', top: 15, left: 15, zIndex: 10 }}>
                <a href="https://infinium.consulting/" target="_blank" rel="noopener noreferrer">
                    <img
                        src={nwLogo}
                        alt="Infinium Logo"
                        style={{ height: '45px', objectFit: 'contain' }}
                    />
                </a>
            </Box>

            {/* Full Background Image */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                }}
            >
                <img
                    src={splashImage}
                    alt="splash"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block'
                    }}
                />
            </Box>

            {/* Content Card */}
            <Box
                sx={{
                    position: 'absolute',
                     // Desktop - top left
                    top: { xs: '8%', md: '8%' },
                    left: { xs: '4%', md: '4%' },
                    // Full width on mobile, fixed width on desktop
                    width: { xs: '92%', md: '600px' },
                    zIndex: 5
                }}
            >
                <Card sx={{ p: { xs: 2, md: 4 }, borderRadius: 4, boxShadow: 8, maxHeight: { xs: '90vh', md: 'none' }, overflowY: { xs: 'auto', md: 'visible' }  }}>
                    <CardContent>
                        {/* Title */}
                        <Typography variant="h4" fontWeight="bold" gutterBottom>
                            {info.title}
                        </Typography>

                        {/* Duration */}
                        {info.duration && (
                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                ⏱ Estimated time: {info.duration}
                            </Typography>
                        )}

                        <Divider sx={{ my: 2 }} />

                        {/* Description */}
                        <Typography variant="body1" gutterBottom>
                            {info.description}
                        </Typography>

                        {/* Instructions */}
                        {info.instructions.length > 0 && (
                            <>
                                <Typography variant="h6" fontWeight="bold" sx={{ mt: 2 }}>
                                    Before you begin:
                                </Typography>
                                <List dense>
                                    {info.instructions.map((instruction, index) => (
                                        <ListItem key={index} sx={{ py: 0.5 }}>
                                            <ListItemText primary={`• ${instruction}`} />
                                        </ListItem>
                                    ))}
                                </List>
                            </>
                        )}

                        {/* Note */}
                        {info.note && (
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ mt: 2, fontStyle: 'italic' }}
                            >
                                {info.note}
                            </Typography>
                        )}

                        <Divider sx={{ my: 2 }} />

                        {/* Buttons */}
                        <Box display="flex" gap={2} mt={2}>
                            <Button
                                variant="outlined"
                                fullWidth
                                onClick={() => navigate(`/${userId}`)}
                            >
                                Back
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => navigate(`/test/${userId}/${application}`)}
                            >
                                Continue
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default AssessmentInfoPage;